import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description HouseSearch icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { HouseSearch } from '@sravni/design-system-icons'
 *
 * <HouseSearch />
 * ```
 */
var HouseSearch = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "HouseSearch", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m.714 9.613 8.467-7.165a1.253 1.253 0 0 1 1.64 0l8.466 7.164", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M17.143 7.857v8.572c0 .79-.64 1.428-1.429 1.428H4.286c-.79 0-1.429-.639-1.429-1.428V7.857", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M10.914 8.326a2.488 2.488 0 1 1-3.518 3.518 2.488 2.488 0 0 1 3.518-3.518ZM10.896 12.573l2.437 2.47", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { HouseSearch };
//# sourceMappingURL=HouseSearch.js.map
